import { ConsentStatus } from '@airgrid/edgekit';

export const isUserInteractionComplete = (
  consentStatus: ConsentStatus
): boolean => {
  return (
    consentStatus.eventStatus === 'tcloaded' ||
    consentStatus.eventStatus === 'useractioncomplete'
  );
};

export const hasCmpBeenShownAndConsentRejected = (
  consentStatus: ConsentStatus
): boolean => {
  return !consentStatus.hasConsent && isUserInteractionComplete(consentStatus);
};

export const hasCmpBeenShownAndConsentGranted = (
  consentStatus: ConsentStatus
): boolean => {
  return consentStatus.hasConsent && isUserInteractionComplete(consentStatus);
};
